import { z } from 'zod';

/**
 * Module C · Verba Mensal — spending envelope per (project, month, category).
 *
 * The summary derives `actualCents` from receipts + payments grouped by
 * the linked budget_item's category (or 'outros' when unlinked). This is
 * computed in the service layer, never persisted.
 */

export const verbaCategorySchema = z.enum([
  'obra', 'material', 'mao_obra', 'servico', 'equipamento', 'outros',
]);
export type VerbaCategory = z.infer<typeof verbaCategorySchema>;

export const monthlyBudgetSchema = z.object({
  id: z.string(),
  projectId: z.string(),
  yearMonth: z.string(),
  category: verbaCategorySchema,
  plannedCents: z.number().int().nonnegative(),
  notes: z.string().nullable(),
  createdAt: z.string(),
});
export type MonthlyBudget = z.infer<typeof monthlyBudgetSchema>;

export const upsertMonthlyBudgetRequestSchema = z.object({
  projectId: z.string().min(1),
  yearMonth: z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/),
  category: verbaCategorySchema,
  plannedCents: z.number().int().nonnegative(),
  notes: z.string().max(500).nullable().optional(),
});
export type UpsertMonthlyBudgetRequest = z.infer<typeof upsertMonthlyBudgetRequestSchema>;

export const verbaMonthRowSchema = z.object({
  yearMonth: z.string(),
  category: verbaCategorySchema,
  plannedCents: z.number().int(),
  actualCents: z.number().int(),
  varianceCents: z.number().int(),
  overBudget: z.boolean(),
});
export type VerbaMonthRow = z.infer<typeof verbaMonthRowSchema>;

export const verbaSummarySchema = z.object({
  projectId: z.string(),
  rows: z.array(verbaMonthRowSchema),
  totalPlannedCents: z.number().int(),
  totalActualCents: z.number().int(),
  monthsOverBudget: z.array(z.string()),
});
export type VerbaSummary = z.infer<typeof verbaSummarySchema>;
